import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "Cowrieking · Mershack Kabu Aklie";
const SITE_URL = "https://cowrieking.com";
const DEFAULT_OG = "https://static.prod-images.emergentagent.com/jobs/044129a6-116c-4bc2-ad36-aa46b4cd58c6/images/daed7efc0f68fe2fb8fff53ca20041141fb6a3c5b61aeab7e8cb77091e42a377.png";
const DEFAULT_DESC = "Ghanaian photographer, storyteller, humanitarian, and founder of Eyes of Hope Foundation. Documenting humanity, preserving African identity, transforming stories into impact.";

export default function SEO({
  title,
  description = DEFAULT_DESC,
  image = DEFAULT_OG,
  path = "",
  type = "website",
  schema,
  breadcrumbs,
  keywords,
  noindex = false,
}) {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : SITE_NAME;
  const url = `${SITE_URL}${path}`;

  const personSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: "Mershack Kabu Aklie",
    alternateName: "Cowrieking",
    url: SITE_URL,
    image: DEFAULT_OG,
    jobTitle: "Photographer, Storyteller, Humanitarian",
    nationality: "Ghanaian",
    description,
    worksFor: {
      "@type": "NGO",
      name: "Eyes of Hope Foundation",
      url: `${SITE_URL}/eyes-of-hope`,
    },
    knowsAbout: ["Documentary Photography", "African Culture", "Ada Heritage", "Humanitarian Work", "Ghana"],
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: SITE_URL,
    description: DEFAULT_DESC,
    publisher: { "@type": "Person", name: "Mershack Kabu Aklie", alternateName: "Cowrieking" },
  };

  const breadcrumbSchema = breadcrumbs && breadcrumbs.length
    ? {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.name,
          item: `${SITE_URL}${b.path}`,
        })),
      }
    : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="theme-color" content="#0a0908" />
      <meta name="author" content="Mershack Kabu Aklie" />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />
      <script type="application/ld+json">{JSON.stringify(schema || personSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      {breadcrumbSchema && (
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      )}
    </Helmet>
  );
}
